import { COLORS } from '../../common/utils/icon/constants';
import { getIcon } from '../../common/utils/icon/icon';
const getStyles = notNeutral => `
  height: auto;
  ${notNeutral && 'margin-top: 7%'};
  width: ${notNeutral ? '61%' : '100%'};
`;
const configuration = {
  colors: [COLORS.blue, COLORS.white],
  getStyles,
  id: 'shield',
  useJaggedBackground: true
};
export default type => getIcon({
  ...configuration,
  type
});
//# sourceMappingURL=icon.js.map